
import { LayerItem } from '@/types';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class LegendMenu extends Vue {
  @Prop() readonly showMenu!: boolean;

  panels = [0];
  collapsed = false;

  mounted() {
    this.emitSize();
  }

  get menuItems(): LayerItem[] {
    const layers: LayerItem[] = [];
    this.$store.getters.menuItems.forEach((item: LayerItem) => {
      if (!item.hidden) {
        layers.push(item);
      }
    });
    return layers;
  }

  collapse() {
    this.collapsed = !this.collapsed;
    this.emitSize();
  }

  emitSize() {
    if (this.$refs.LowerLegend) {
      var callCount = 1; // Emit the updated height over time as the menu expands or collapses
      var repeater = setInterval(() => {
        if (callCount < 15) {
          const element = this.$refs.LowerLegend as HTMLElement;
          const height = element.clientHeight;

          this.$emit('collapse', height);
          callCount += 1;
        } else {
          clearInterval(repeater);
        }
      }, 10);
    }
  }

  setLayer(
    listItem: LayerItem,
    type: 'check' | 'radio',
    radioValue?: string | undefined,
  ) {
    this.$store.commit('setLayerSelection', {
      layerItem: listItem,
      updateType: type,
      radioValue: radioValue,
    });
    this.$emit('toggleLayer', {
      layerName: listItem.layerInfo.source.id,
      selected: listItem.selected,
    });
  }
}
